import { render, staticRenderFns } from "./NavbarApp.vue?vue&type=template&id=edb99d22&scoped=true&"
import script from "./NavbarApp.vue?vue&type=script&lang=ts&"
export * from "./NavbarApp.vue?vue&type=script&lang=ts&"
import style0 from "./NavbarApp.vue?vue&type=style&index=0&id=edb99d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb99d22",
  null
  
)

export default component.exports